export default "__VITE_ASSET__ae3286fc__"